import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle,MDBAlert } from 'mdb-react-ui-kit'
import { deleteStreamApiApp } from '../../../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';


function ApiAppDeletePopup(props) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [isError, setError] = useState(false);

    console.log("ApiAppDeletePopup info ::: " + JSON.stringify(props));
    //{"open":true,"info":{"id":1226,"appname":"HashamTest",
    //"client_id":"5wdXgZH4AkYueZlb","client_secret":"1JwtXlDHBrr5up1dn9CsFTsUnp5TsM0m","status":1}}
    const deleteApp = async (deleteInfo) => {
        console.log("ApiAppDeletePopup  ::: " + JSON.stringify(deleteInfo));
        try {
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const serverResponse = await deleteStreamApiApp(siteid, deleteInfo.id, deleteInfo);
            if (!serverResponse.ok) {
                console.log("Network response was not ok");
                setError(true);
                setTimeout(() => {
                    setError(false)
                },2000)
            } else {
                const responseData = await serverResponse.json()
                console.log("responseData ::: : " + JSON.stringify(responseData));
                props.setOpen(false);
                navigate("/apilanding", { state: { defaultTab: "tab3" } });
                localStorage.setItem("s_message", ` ${props.info.appname} Api app deleted successfully.`);
                window.location.reload();
            }
        } catch (error) {
            console.log("Error  [getAccountStreamApiApps] " + error);
        }
    }

    return (
        <>
        <MDBModal tabIndex="-1" open={props.open} onClose={() => props.setOpen(false)} >
            <MDBModalDialog>
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Delete - {props.info.appname} </MDBModalTitle>
                        <MDBBtn className="btn-close" color="none" onClick={() => { props.setOpen(false) }}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody> <b>WARNING!</b> Deleting this App will remove all access tokens if any created by this API app. Are you sure you want to delete this API App?</MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn size="sm" color="secondary" onClick={() => { props.setOpen(false) }}>
                            Cancel
                        </MDBBtn>
                        <MDBBtn size="sm" color="danger" onClick={() => { deleteApp(props.info) }} >
                            Delete App
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
            {isError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={3000}
                >
                    {t("Provisioning_Error_Aleart")}
                </MDBAlert>
            )}
        </>
    )
}

export default ApiAppDeletePopup;